import React from 'react';

const About = () => {
  return (
    <div className="bg-slate-950 text-slate-100 min-h-screen font-sans antialiased py-24 relative overflow-hidden">
      {/* Decorative Ambient Radial Glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-7xl h-[500px] bg-[radial-gradient(circle_at_top,rgba(99,102,241,0.1),transparent_50%)] pointer-events-none z-0" />

      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 relative z-10">
        
        {/* PAGE HEADER */}
        <div className="border-b border-slate-900 pb-10 mb-12 text-center sm:text-left">
          <span className="text-xs font-bold uppercase tracking-widest text-indigo-400 bg-indigo-950/40 px-3 py-1 rounded border border-indigo-900/40">
            Behind the Network
          </span>
          <h1 className="text-4xl font-black text-white sm:text-5xl tracking-tight mt-4">
            Our Mission & Vision
          </h1>
          <p className="mt-4 text-slate-400 text-lg leading-relaxed font-medium">
            Discover the philosophy driving MoreView's high-value information distribution ecosystem.
          </p>
        </div>

        {/* CORE CONTENT BLOCK */}
        <div className="space-y-8 text-slate-300 text-base leading-relaxed font-medium">
          <p>
            In an era overwhelmed by digital noise, finding pure, unadulterated insight can feel nearly impossible. <strong className="text-white">MoreView</strong> was engineered to bridge that critical gap. We operate as an exclusive distribution terminal delivering curated strategies, structural breakdowns, and technical perspectives directly to your inbox.
          </p>
          
          <blockquote className="border-l-2 border-indigo-500 bg-slate-900/40 px-6 py-4 rounded-r-xl my-6 font-mono text-sm text-indigo-300">
            "We believe that the best content shouldn't have to be hunted down—it should meet you exactly where you are, formatted beautifully and structured intentionally."
          </blockquote>

          <h2 className="text-xl font-bold text-white pt-4">Why Follow Our Journal?</h2>
          <p>
            When you subscribe to our platform or land on our mirrored public logs via our email dispatches, you are engaging with insights designed for immediate utility. Our topics cut straight through the surface level to offer deep, actionable value across modern growth metrics, intelligent systems architecture, and execution models.
          </p>
        </div>

        {/* VALUE PILLARS GRID */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mt-12 pt-10 border-t border-slate-900">
          <div className="p-5 rounded-xl bg-slate-900/40 border border-slate-900">
            <h3 className="font-bold text-white text-lg">🎯 Quality First</h3>
            <p className="text-sm text-slate-400 mt-2">No filler content, no low-effort updates. Every edition is researched and structured to give you maximal strategic leverage.</p>
          </div>
          <div className="p-5 rounded-xl bg-slate-900/40 border border-slate-900">
            <h3 className="font-bold text-white text-lg">⚡ Absolute Clarity</h3>
            <p className="text-sm text-slate-400 mt-2">Complex frameworks broken down into clean, scannable documentation that makes learning seamless.</p>
          </div>
        </div>

      </div>
    </div>
  );
};

export default About;
